<template>
    <div class="header-toolbar">
        <div class="left-section" v-show="leftDiv === 'blank'">
        </div>
        <div class="left-section" v-show="leftDiv === 'back'"  @click="$router.go(-1)">
            <ion-icon name="md-arrow-back"></ion-icon>
        </div>
        <div class="left-section" v-show="leftDiv === 'url'"  @click="$router.push('/mypage/main')">
            <ion-icon name="md-arrow-back"></ion-icon>
        </div>

        <div class="title">
            <div><span>{{ colorTitle }}</span>{{ title }}</div>
        </div>

        <div class="right-section" @click="closeEvent">
            <ion-icon v-show="rightDiv === 'close'" name="md-close"></ion-icon>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CommonHeader",
        props: {
            leftDiv: String,
            colorTitle: String,
            title: String,
            rightDiv: String
        },
        data() {
            return {
            }
        },
        methods: {
            closeEvent() {
                this.$emit("closeEvent");
            }
        }
    }
</script>

<style scoped lang="scss">
    div.header-toolbar {
        width: 100%;
        height: 56px;
        background-color: white;
        border-bottom: 1px solid $line-third-color;

        display: flex;
        justify-content: space-between;
        align-items: center;

        div.left-section {
            width: 48px;
            padding-left: 24px;
            font-size: $font-base24;
        }
        div.title {
            flex: 1;
            text-align: center;
            font-size: $font-base18;
            font-weight: $font-weight500;

            span {
                color: $primary-color;
            }
        }
        div.right-section {
            width: 48px;
            text-align: right;
            padding-right: 24px;
            img {
                margin-left: 10px;
            }
        }
    }
</style>
